import { render, staticRenderFns } from "./TextFieldDate.vue?vue&type=template&id=126f28a6&scoped=true"
import script from "./TextFieldDate.vue?vue&type=script&lang=js"
export * from "./TextFieldDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126f28a6",
  null
  
)

export default component.exports